import { type UseQuery, UseQueryOptions } from '@/store';
import { PatientId, useDefaultQueryOptions } from '@/modules/surgicalEvent';
import { usePollingWhenInView } from './usePollingWhenInView';
import { useCurrentPatientIdParam } from '../useCurrentPatientIdParam';
import { skipToken, SkipToken } from '@reduxjs/toolkit/query';

export type UseQueryForCurrentPatientParam<T, ARG = unknown> = {
  useQuery: UseQuery<T, PatientId & ARG>;
  queryConfig?: UseQueryOptions<T, PatientId & ARG>;
  queryArg?: ARG | SkipToken;
  pollingInView?: {
    observeElementId: string;
    pollingMs?: number;
    skipWhileOut?: boolean;
    refetchWhenIn?: boolean;
  };
};

export const useQueryForCurrentPatient = <T, ARG = unknown>({
  useQuery,
  queryArg,
  queryConfig,
  pollingInView
}: UseQueryForCurrentPatientParam<T, ARG>) => {
  const patientId = useCurrentPatientIdParam() ?? '';
  const defaultConfig = useDefaultQueryOptions() as any;
  const arg =
    queryArg === skipToken ? queryArg : ({ ...queryArg, patientId } as any);
  const { observeElementId, ...pollingProps } = pollingInView ?? {};
  return usePollingWhenInView({
    elementId: observeElementId,
    useQuery,
    queryArg: arg,
    queryConfig: {
      ...(defaultConfig as any),
      ...queryConfig,
      skip: !patientId || queryConfig?.skip || defaultConfig?.skip
    },
    ...pollingProps
  });
};
